export enum QrAccessCodeType {
  Static = 'STATIC',
  Dynamic = 'DYNAMIC'
}
